export const BlockIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M2.40747 12.2209C1.63026 11.4437 1.24166 11.0551 1.09606 10.607C0.967982 10.2128 0.967982 9.78819 1.09606 9.39402C1.24166 8.94591 1.63026 8.5573 2.40747 7.78009L7.77961 2.40796C8.55682 1.63075 8.94542 1.24214 9.39353 1.09654C9.7877 0.96847 10.2123 0.96847 10.6065 1.09654C11.0546 1.24214 11.4432 1.63075 12.2204 2.40796L17.5925 7.78009C18.3697 8.5573 18.7583 8.94591 18.9039 9.39402C19.032 9.78819 19.032 10.2128 18.9039 10.607C18.7583 11.0551 18.3697 11.4437 17.5925 12.2209L12.2204 17.593C11.4432 18.3702 11.0546 18.7588 10.6065 18.9044C10.2123 19.0325 9.7877 19.0325 9.39353 18.9044C8.94542 18.7588 8.55682 18.3702 7.7796 17.593L2.40747 12.2209Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const AdvancedBlockIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M14.9066 5.09413L12.2204 2.40796C11.4432 1.63075 11.0546 1.24214 10.6065 1.09654C10.2123 0.96847 9.7877 0.96847 9.39353 1.09654C8.94542 1.24214 8.55682 1.63075 7.77961 2.40796L5.09354 5.09403M14.9066 5.09413L17.5925 7.78009C18.3697 8.5573 18.7583 8.94591 18.9039 9.39402C19.032 9.78819 19.032 10.2128 18.9039 10.607C18.7583 11.0551 18.3697 11.4437 17.5925 12.2209L14.9065 14.907M14.9066 5.09413L5.09354 14.9069M5.09354 14.9069L7.7796 17.593C8.55682 18.3702 8.94542 18.7588 9.39353 18.9044C9.7877 19.0325 10.2123 19.0325 10.6065 18.9044C11.0546 18.7588 11.4432 18.3702 12.2204 17.593L14.9065 14.907M5.09354 14.9069L2.40747 12.2209C1.63026 11.4437 1.24166 11.0551 1.09606 10.607C0.967982 10.2128 0.967982 9.78819 1.09606 9.39402C1.24166 8.94591 1.63026 8.5573 2.40747 7.78009L5.09354 5.09403M14.9065 14.907L5.09354 5.09403'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const HeroIcon = ({ className = '' }) => {
	return (
		<>
			<svg width='13' height='16' viewBox='0 0 13 16' aria-hidden='true' focusable='false'>
				<path
					d='M1 3.48889C1 2.6177 1 2.1821 1.16955 1.84935C1.31868 1.55665 1.55665 1.31868 1.84935 1.16955C2.1821 1 2.6177 1 3.48889 1H9.4C10.2712 1 10.7068 1 11.0395 1.16955C11.3322 1.31868 11.5702 1.55665 11.7193 1.84935C11.8889 2.1821 11.8889 2.6177 11.8889 3.48889V15L6.44444 11.1111L1 15V3.48889Z'
					className={className}
					stroke='#1B30F5'
					strokeWidth='1.5'
					strokeLinecap='round'
					strokeLinejoin='round'
					fill='transparent'
				></path>
			</svg>
		</>
	);
};

export const EventsIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='16'
			height='16'
			viewBox='0 0 16 16'
			aria-hidden='true'
			focusable='false'
		>
			<path
				d='M1 5.66667H15M4.11111 1V2.55556M11.8889 1V2.55556M3.33333 8.77778H4.88889M3.33333 11.8889C3.33333 11.8889 4.28141 11.8889 4.88889 11.8889M7.22222 8.77778H8.77778M7.22222 11.8889H8.77778M11.1111 8.77778H12.6667M11.1111 11.8889H12.6667M3.48889 15H12.5111C13.3823 15 13.8179 15 14.1507 14.8305C14.4433 14.6813 14.6813 14.4433 14.8305 14.1507C15 13.8179 15 13.3823 15 12.5111V5.04444C15 4.17325 15 3.73766 14.8305 3.4049C14.6813 3.11221 14.4433 2.87424 14.1507 2.7251C13.8179 2.55556 13.3823 2.55556 12.5111 2.55556H3.48889C2.6177 2.55556 2.1821 2.55556 1.84935 2.7251C1.55665 2.87424 1.31868 3.11221 1.16955 3.4049C1 3.73766 1 4.17325 1 5.04444V12.5111C1 13.3823 1 13.8179 1.16955 14.1507C1.31868 14.4433 1.55665 14.6813 1.84935 14.8305C2.1821 15 2.6177 15 3.48889 15Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const EditorIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M4.1812 3.99587L5.53994 2.63713C6.15941 2.01766 6.46914 1.70793 6.8263 1.59188C7.14047 1.4898 7.47889 1.4898 7.79306 1.59188C8.15022 1.70793 8.45995 2.01766 9.07942 2.63712L9.65602 3.21384M6.52756 6.34223L9.65604 9.47071M6.13652 12.9904C6.65117 12.4758 11.7239 7.40301 14.3519 4.77507C15.2158 3.91113 15.2127 2.51355 14.3488 1.64959C13.4848 0.785582 12.0872 0.782426 11.2232 1.64641C8.59524 4.27439 3.52261 9.34703 3.00794 9.86166C1.61218 11.2573 0.776175 14.669 1.05264 14.9454C1.32911 15.2219 4.6979 14.429 6.13652 12.9904Z'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const ColumnsIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 13' aria-hidden='true' focusable='false'>
			<path
				d='M5.66667 1V11.8889M10.3333 1V11.8889M3.48889 11.8889H12.5111C13.3823 11.8889 13.8179 11.8889 14.1507 11.7193C14.4433 11.5702 14.6813 11.3322 14.8305 11.0395C15 10.7068 15 10.2712 15 9.4V3.48889C15 2.6177 15 2.1821 14.8305 1.84935C14.6813 1.55665 14.4433 1.31868 14.1507 1.16955C13.8179 1 13.3823 1 12.5111 1H3.48889C2.6177 1 2.1821 1 1.84935 1.16955C1.55665 1.31868 1.31868 1.55665 1.16955 1.84935C1 2.1821 1 2.6177 1 3.48889V9.4C1 10.2712 1 10.7068 1.16955 11.0395C1.31868 11.3322 1.55665 11.5702 1.84935 11.7193C2.1821 11.8889 2.6177 11.8889 3.48889 11.8889Z'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const FactFiguresIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M10.7222 5.27778L5.27778 10.7222M6.05556 6.05556H6.06333M9.94444 9.94444H9.95222M6.44444 6.05556C6.44444 6.27033 6.27033 6.44444 6.05556 6.44444C5.84078 6.44444 5.66667 6.27033 5.66667 6.05556C5.66667 5.84078 5.84078 5.66667 6.05556 5.66667C6.27033 5.66667 6.44444 5.84078 6.44444 6.05556ZM10.3333 9.94444C10.3333 10.1592 10.1592 10.3333 9.94444 10.3333C9.72967 10.3333 9.55556 10.1592 9.55556 9.94444C9.55556 9.72967 9.72967 9.55556 9.94444 9.55556C10.1592 9.55556 10.3333 9.72967 10.3333 9.94444ZM11.3668 2.36776C11.9414 2.38416 12.5112 2.61165 12.9497 3.05023C13.3883 3.4888 13.6158 4.05853 13.6322 4.63317C13.6484 5.2018 13.6566 5.48612 13.6732 5.5523C13.709 5.69396 13.6675 5.59375 13.7424 5.71918C13.7774 5.77778 13.9727 5.98459 14.3633 6.39813C14.758 6.81605 15 7.37976 15 8C15 8.62024 14.758 9.18395 14.3633 9.60187C13.9727 10.0154 13.7774 10.2222 13.7424 10.2808C13.6675 10.4062 13.709 10.306 13.6732 10.4477C13.6566 10.5139 13.6484 10.7982 13.6322 11.3668C13.6158 11.9415 13.3883 12.5112 12.9497 12.9498C12.5112 13.3884 11.9414 13.6158 11.3668 13.6322C10.7982 13.6485 10.5139 13.6566 10.4477 13.6733C10.306 13.709 10.4062 13.6675 10.2808 13.7424C10.2222 13.7774 10.0154 13.9727 9.60187 14.3633C9.18394 14.758 8.62023 15 8 15C7.37977 15 6.81607 14.758 6.39815 14.3633C5.98457 13.9727 5.77779 13.7774 5.71919 13.7424C5.59376 13.6675 5.69397 13.709 5.55231 13.6733C5.48613 13.6566 5.20175 13.6485 4.63316 13.6322C4.05852 13.6158 3.48878 13.3884 3.0502 12.9498C2.61161 12.5112 2.38413 11.9414 2.36773 11.3668C2.35152 10.7982 2.34341 10.5139 2.32672 10.4477C2.291 10.306 2.3325 10.4062 2.2576 10.2808C2.2226 10.2222 2.0273 10.0154 1.6367 9.60185C1.24199 9.18393 1 8.62022 1 8C1 7.37978 1.24199 6.81607 1.6367 6.39815C2.0273 5.98459 2.2226 5.7778 2.2576 5.71921C2.3325 5.59378 2.291 5.69399 2.32672 5.55232C2.34341 5.48615 2.35152 5.20183 2.36773 4.6332C2.38413 4.05855 2.61161 3.48881 3.0502 3.05023C3.48878 2.61164 4.05852 2.38416 4.63316 2.36776C5.2018 2.35154 5.48613 2.34343 5.5523 2.32674C5.69397 2.29102 5.59376 2.33253 5.71919 2.25762C5.77778 2.22263 5.98459 2.0273 6.39815 1.63671C6.81607 1.24199 7.37977 1 8 1C8.62023 1 9.18394 1.242 9.60187 1.63672C10.0154 2.02732 10.2222 2.22262 10.2808 2.25761C10.4062 2.33252 10.306 2.29101 10.4477 2.32674C10.5139 2.34343 10.7982 2.35154 11.3668 2.36776Z'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const FormIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M4.5 8.4375L6.6875 10.625L11.5 5.375M3.8 15H12.2C13.1801 15 13.6701 15 14.0445 14.8093C14.3738 14.6415 14.6415 14.3738 14.8093 14.0445C15 13.6701 15 13.1801 15 12.2V3.8C15 2.81991 15 2.32986 14.8093 1.95552C14.6415 1.62623 14.3738 1.35852 14.0445 1.19074C13.6701 1 13.1801 1 12.2 1H3.8C2.81991 1 2.32986 1 1.95552 1.19074C1.62623 1.35852 1.35852 1.62623 1.19074 1.95552C1 2.32986 1 2.81991 1 3.8V12.2C1 13.1801 1 13.6701 1.19074 14.0445C1.35852 14.3738 1.62623 14.6415 1.95552 14.8093C2.32986 15 2.81991 15 3.8 15Z'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const ImageIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M9.98089 11.4453L8.52135 9.99794C7.81704 9.2995 7.46488 8.95028 7.06075 8.82261C6.70532 8.71032 6.32333 8.71445 5.97042 8.8344C5.56914 8.97079 5.22463 9.32755 4.5356 10.0411L1.03858 13.4951M9.98089 11.4453L10.2796 11.1491C10.9848 10.4498 11.3374 10.1001 11.7419 9.97253C12.0977 9.86029 12.48 9.86469 12.8331 9.98507C13.2346 10.122 13.5791 10.4796 14.268 11.195L15 11.9318M9.98089 11.4453L13.4906 14.962M13.4906 14.962C13.1779 15 12.7726 15 12.2 15H3.8C2.81991 15 2.32986 15 1.95552 14.8093C1.62623 14.6415 1.35852 14.3738 1.19074 14.0445C1.11197 13.8899 1.06573 13.7156 1.03858 13.4951M13.4906 14.962C13.7132 14.9349 13.8888 14.8886 14.0445 14.8093C14.3738 14.6415 14.6415 14.3738 14.8093 14.0445C15 13.6701 15 13.1801 15 12.2V11.9318M1.03858 13.4951C1 13.1818 1 12.7753 1 12.2V3.8C1 2.81991 1 2.32986 1.19074 1.95552C1.35852 1.62623 1.62623 1.35852 1.95552 1.19074C2.32986 1 2.81991 1 3.8 1H12.2C13.1801 1 13.6701 1 14.0445 1.19074C14.3738 1.35852 14.6415 1.62623 14.8093 1.95552C15 2.32986 15 2.81991 15 3.8V11.9318M12.375 5.37491C12.375 6.3414 11.5915 7.12491 10.625 7.12491C9.6585 7.12491 8.875 6.3414 8.875 5.37491C8.875 4.40841 9.6585 3.62491 10.625 3.62491C11.5915 3.62491 12.375 4.40841 12.375 5.37491Z'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const NewsIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='16'
			height='16'
			viewBox='0 0 16 16'
			aria-hidden='true'
			focusable='false'
		>
			<path
				d='M11.8889 8.65975H15V13.3264C15 14.1855 14.3036 14.882 13.4444 14.882M11.8889 8.65975V13.3264C11.8889 14.1855 12.5853 14.882 13.4444 14.882M11.8889 8.65975V3.02637C11.8889 2.32218 11.8889 1.97008 11.741 1.7659C11.6119 1.58778 11.4135 1.47263 11.1948 1.44896C10.9441 1.42182 10.6384 1.59651 10.027 1.94589L9.78408 2.08472C9.55904 2.21331 9.44652 2.27761 9.32702 2.30279C9.22128 2.32507 9.11205 2.32507 9.00631 2.30279C8.88681 2.27761 8.77429 2.21331 8.54925 2.08472L7.06186 1.23478C6.83682 1.10619 6.7243 1.04189 6.6048 1.01671C6.49906 0.99443 6.38983 0.99443 6.28409 1.01671C6.16459 1.04189 6.05207 1.10619 5.82703 1.23478L4.33964 2.08472C4.1146 2.21331 4.00208 2.27761 3.88258 2.30279C3.77683 2.32507 3.66761 2.32507 3.56187 2.30279C3.44237 2.27761 3.32985 2.21331 3.1048 2.08472L2.86186 1.94589C2.25045 1.59651 1.94474 1.42182 1.69407 1.44896C1.4754 1.47263 1.27698 1.58778 1.14793 1.7659C1 1.97008 1 2.32218 1 3.02637V11.1486C1 12.4554 1 13.1088 1.25432 13.6079C1.47802 14.047 1.83498 14.4039 2.27402 14.6277C2.77315 14.882 3.42654 14.882 4.73333 14.882H13.4444M4.11111 8.65975H5.66667M4.11111 5.54864H8.77778M4.11111 11.7709H5.66667M8.77778 11.7709H8.78556M8.77778 8.65975H8.78556'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const TeamsIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M4.625 16C4.625 13.5838 6.58375 11.625 9 11.625C11.4162 11.625 13.375 13.5838 13.375 16M4.8 16H13.2C14.1801 16 14.6701 16 15.0445 15.8093C15.3738 15.6415 15.6415 15.3738 15.8093 15.0445C16 14.6701 16 14.1801 16 13.2V4.8C16 3.81991 16 3.32986 15.8093 2.95552C15.6415 2.62623 15.3738 2.35852 15.0445 2.19074C14.6701 2 14.1801 2 13.2 2H4.8C3.81991 2 3.32986 2 2.95552 2.19074C2.62623 2.35852 2.35852 2.62623 2.19074 2.95552C2 3.32986 2 3.81991 2 4.8V13.2C2 14.1801 2 14.6701 2.19074 15.0445C2.35852 15.3738 2.62623 15.6415 2.95552 15.8093C3.32986 16 3.81991 16 4.8 16ZM10.75 7.25C10.75 8.2165 9.9665 9 9 9C8.0335 9 7.25 8.2165 7.25 7.25C7.25 6.2835 8.0335 5.5 9 5.5C9.9665 5.5 10.75 6.2835 10.75 7.25Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ShortcodeIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='15' viewBox='0 0 16 15' aria-hidden='true' focusable='false'>
			<path
				d='M4.11111 4.11111L1 7.22222L4.11111 10.3333M9.55556 1L6.44444 13.4444M11.8889 4.11111L15 7.22222L11.8889 10.3333'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const TxtImgIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M9.23548 10.6253L6.72395 7.06725C6.32398 6.50063 6.12399 6.21732 5.87803 6.12182C5.66294 6.03831 5.42357 6.04314 5.21203 6.13526C4.97011 6.24061 4.78172 6.53175 4.40494 7.11405L1.22518 12.0282C1.14171 12.1572 1.09998 12.2217 1.07042 12.2912C1.04418 12.3529 1.02513 12.4174 1.01362 12.4835C1.00066 12.5579 1.00064 12.6347 1.0006 12.7884L1 15H14.9998L14.9998 12.778C14.9998 12.6281 14.9998 12.5532 14.9875 12.4805C14.9765 12.416 14.9584 12.3529 14.9334 12.2924C14.9052 12.2243 14.8654 12.1609 14.7857 12.0339L13.9404 10.6867C13.1934 9.49614 12.8199 8.90086 12.3345 8.68382C11.9101 8.49408 11.4277 8.48098 10.9937 8.64741C10.4972 8.83778 10.092 9.41191 9.28141 10.5602L9.23548 10.6253ZM9.23548 10.6253L12.3345 15'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			/>
			<path
				d='M12.9002 5.19973V1M10.8003 1H15'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			/>
		</svg>
	);
};

export const VideoIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' aria-hidden='true' focusable='false'>
			<path
				d='M9.55556 1H4.88889C4.16409 1 3.80169 1 3.51583 1.11841C3.13467 1.27629 2.83184 1.57912 2.67397 1.96027C2.55556 2.24614 2.55556 2.99742 2.55556 3.72222V4.11177M3.33333 6.44444H8.77778M2.55556 4.11177C2.65034 4.11111 2.75361 4.11111 2.86667 4.11111H9.24444C9.89784 4.11111 10.2245 4.11111 10.4741 4.23827C10.6936 4.35012 10.8721 4.5286 10.984 4.74812C11.1111 4.99769 11.1111 5.32438 11.1111 5.97778V10.9556C11.1111 11.8267 11.1111 12.2623 10.9416 12.5951C10.7924 12.8878 10.5545 13.1258 10.2618 13.2749C9.92901 13.4444 9.49342 13.4444 8.62222 13.4444H3.48889C2.6177 13.4444 2.1821 13.4444 1.84935 13.2749C1.55665 13.1258 1.31868 12.8878 1.16955 12.5951C1 12.2623 1 11.8267 1 10.9556V5.97778C1 5.32438 1 4.99769 1.12716 4.74812C1.23901 4.5286 1.41749 4.35012 1.63701 4.23827C1.84339 4.13311 2.10253 4.11492 2.55556 4.11177ZM11.1111 7.22222L14.0576 5.4543C14.3661 5.26924 14.5203 5.1767 14.6472 5.18853C14.7579 5.19884 14.8588 5.256 14.9246 5.34557C15 5.4483 15 5.62815 15 5.98785V11.5677C15 11.9274 15 12.1073 14.9246 12.21C14.8588 12.2996 14.7579 12.3567 14.6472 12.367C14.5203 12.3789 14.3661 12.2863 14.0576 12.1013L11.1111 10.3333'
				className={className}
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			></path>
		</svg>
	);
};

export const FaqsIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='16'
			height='16'
			viewBox='0 0 16 16'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7.99964 8.5842C8.72989 7.85395 9.46012 7.56519 9.46012 6.75858C9.46012 5.95197 8.80624 5.29808 7.99963 5.29808C7.3191 5.29808 6.74728 5.76353 6.58515 6.39346M8 10.7749H8.0073M13.454 9.84853L14.4763 8.82618C14.7655 8.53699 14.9101 8.3924 14.9643 8.22566C15.0119 8.07899 15.0119 7.92101 14.9643 7.77434C14.9101 7.60761 14.7655 7.46301 14.4763 7.17382L13.454 6.15147C13.3277 6.02517 13.2645 5.96203 13.2193 5.88833C13.1793 5.82299 13.1498 5.75176 13.1319 5.67725C13.1117 5.59321 13.1117 5.5039 13.1117 5.32529V4.05666C13.1117 3.64768 13.1117 3.4432 13.0321 3.28699C12.9621 3.14958 12.8504 3.03787 12.713 2.96786C12.5568 2.88827 12.3523 2.88827 11.9433 2.88827H10.6747C10.4961 2.88827 10.4068 2.88827 10.3228 2.86809C10.2482 2.8502 10.177 2.82069 10.1117 2.78066C10.038 2.7355 9.97483 2.67235 9.84853 2.54605L8.82618 1.5237C8.53699 1.23451 8.3924 1.08992 8.22566 1.03574C8.07899 0.988086 7.92101 0.988086 7.77434 1.03574C7.6076 1.08992 7.46301 1.23451 7.17382 1.5237L6.15147 2.54605C6.02517 2.67235 5.96203 2.7355 5.88833 2.78066C5.82299 2.82069 5.75176 2.8502 5.67725 2.86809C5.59321 2.88827 5.5039 2.88827 5.32529 2.88827H4.05666C3.64768 2.88827 3.4432 2.88827 3.28699 2.96786C3.14958 3.03787 3.03787 3.14958 2.96786 3.28699C2.88827 3.4432 2.88827 3.64768 2.88827 4.05666V5.32529C2.88827 5.5039 2.88827 5.59321 2.86809 5.67725C2.8502 5.75176 2.82069 5.82299 2.78066 5.88833C2.7355 5.96203 2.67235 6.02517 2.54605 6.15147L1.5237 7.17382C1.23451 7.46301 1.08992 7.60761 1.03574 7.77434C0.988086 7.92101 0.988086 8.07899 1.03574 8.22566C1.08992 8.3924 1.23451 8.53699 1.5237 8.82618L2.54605 9.84853C2.67235 9.97483 2.7355 10.038 2.78066 10.1117C2.82069 10.177 2.8502 10.2482 2.86809 10.3228C2.88827 10.4068 2.88827 10.4961 2.88827 10.6747V11.9433C2.88827 12.3523 2.88827 12.5568 2.96786 12.713C3.03787 12.8504 3.14958 12.9621 3.28699 13.0321C3.4432 13.1117 3.64768 13.1117 4.05666 13.1117H5.32529C5.5039 13.1117 5.59321 13.1117 5.67725 13.1319C5.75176 13.1498 5.82299 13.1793 5.88833 13.2193C5.96203 13.2645 6.02517 13.3277 6.15147 13.454L7.17382 14.4763C7.46301 14.7655 7.6076 14.9101 7.77434 14.9643C7.92101 15.0119 8.07899 15.0119 8.22566 14.9643C8.3924 14.9101 8.53699 14.7655 8.82618 14.4763L9.84853 13.454C9.97483 13.3277 10.038 13.2645 10.1117 13.2193C10.177 13.1793 10.2482 13.1498 10.3228 13.1319C10.4068 13.1117 10.4961 13.1117 10.6747 13.1117H11.9433C12.3523 13.1117 12.5568 13.1117 12.713 13.0321C12.8504 12.9621 12.9621 12.8504 13.0321 12.713C13.1117 12.5568 13.1117 12.3523 13.1117 11.9433V10.6747C13.1117 10.4961 13.1117 10.4068 13.1319 10.3228C13.1498 10.2482 13.1793 10.177 13.2193 10.1117C13.2645 10.038 13.3277 9.97483 13.454 9.84853Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='transparent'
			/>
		</svg>
	);
};

export const ColorIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M6 19.0002H15.8C16.9201 19.0002 17.4802 19.0002 17.908 18.7823C18.2843 18.5905 18.5903 18.2846 18.782 17.9082C19 17.4804 19 16.9203 19 15.8002V14.2002C19 13.0801 19 12.5201 18.782 12.0923C18.5903 11.7159 18.2843 11.41 17.908 11.2182C17.4802 11.0002 16.9201 11.0002 15.8 11.0002H15.6568M9 6.34338L11.2728 4.0706C12.0648 3.27857 12.4608 2.88255 12.9175 2.73418C13.3192 2.60366 13.7519 2.60366 14.1536 2.73418C14.6102 2.88255 15.0062 3.27857 15.7983 4.0706L16.9296 5.20197C17.7217 5.99401 18.1177 6.39002 18.2661 6.84668C18.3966 7.24837 18.3966 7.68106 18.2661 8.08275C18.1177 8.53941 17.7217 8.93542 16.9296 9.72746L15.6568 11.0002M9 6.34338V4.20024C9 3.08014 9 2.52009 8.78201 2.09226C8.59027 1.71594 8.28431 1.40998 7.90798 1.21823C7.48016 1.00024 6.92011 1.00024 5.8 1.00024H4.2C3.0799 1.00024 2.51984 1.00024 2.09202 1.21823C1.71569 1.40998 1.40973 1.71594 1.21799 2.09226C1 2.52009 1 3.08014 1 4.20024V15.8002C1 16.9203 1 17.4804 1.21799 17.9082C1.40973 18.2846 1.71569 18.5905 2.09202 18.7823C2.51984 19.0002 3.07989 19.0002 4.2 19.0002H5.8C6.92011 19.0002 7.48016 19.0002 7.90798 18.7823C8.28431 18.5905 8.59027 18.2846 8.78201 17.9082C8.79262 17.8874 8.80271 17.8663 8.81231 17.8448M9 6.34338V15.8002C9 16.8658 9 17.4246 8.81231 17.8448M15.6568 11.0002L8.81231 17.8448M5 15.0002H5.01'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const FontsIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='20'
			height='16'
			viewBox='0 0 20 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M6 1.00049V15.0005M6 15.0005H4M6 15.0005H8M15 8.00049V15.0005M15 8.00049H11V10.0005M15 8.00049H19V10.0005M15 15.0005H13M15 15.0005H17M11 4.00049V1.00049H1V4.00049'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const PaletteIcon = ({ className = '' }) => {
	return (
		<svg
			strokeWidth='0'
			viewBox='0 0 512 512'
			height='24'
			width='24'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				className={className}
				d='M256 64C150.401 64 64 150.401 64 256c0 105.604 86.401 192 192 192 18.136 0 32-13.864 32-32 0-8.531-3.198-16-8.531-21.333-5.333-5.334-8.531-12.803-8.531-21.334 0-18.135 13.864-32 32-32h38.396c58.667 0 106.667-48 106.667-106.666C448 140.802 361.604 64 256 64zM138.667 256c-18.136 0-32-13.864-32-32s13.864-32 32-32c18.135 0 32 13.864 32 32s-13.865 32-32 32zm64-85.333c-18.136 0-32-13.865-32-32 0-18.136 13.864-32 32-32 18.135 0 32 13.864 32 32 0 18.135-13.865 32-32 32zm106.666 0c-18.135 0-32-13.865-32-32 0-18.136 13.865-32 32-32 18.136 0 32 13.864 32 32 0 18.135-13.864 32-32 32zm64 85.333c-18.135 0-32-13.864-32-32s13.865-32 32-32c18.136 0 32 13.864 32 32s-13.864 32-32 32z'
			></path>
		</svg>
	);
};

export const RemoveIcon = ({ className = '' }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			viewBox='0 0 24 24'
			strokeWidth={1.5}
			stroke='currentColor'
			className='size-6'
		>
			<path
				className={className}
				strokeLinecap='round'
				strokeLinejoin='round'
				d='M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
			/>
		</svg>
	);
};

export const FooterIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M1 1H19M1 5H11M2.6 15H17.4C17.9601 15 18.2401 15 18.454 14.891C18.6422 14.7951 18.7951 14.6422 18.891 14.454C19 14.2401 19 13.9601 19 13.4V10.6C19 10.0399 19 9.75992 18.891 9.54601C18.7951 9.35785 18.6422 9.20487 18.454 9.10899C18.2401 9 17.9601 9 17.4 9H2.6C2.03995 9 1.75992 9 1.54601 9.10899C1.35785 9.20487 1.20487 9.35785 1.10899 9.54601C1 9.75992 1 10.0399 1 10.6V13.4C1 13.9601 1 14.2401 1.10899 14.454C1.20487 14.6422 1.35785 14.7951 1.54601 14.891C1.75992 15 2.03995 15 2.6 15Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const HeaderIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M1 11H19M1 15H11M2.6 7H17.4C17.9601 7 18.2401 7 18.454 6.89101C18.6422 6.79513 18.7951 6.64215 18.891 6.45399C19 6.24008 19 5.96005 19 5.4V2.6C19 2.03995 19 1.75992 18.891 1.54601C18.7951 1.35785 18.6422 1.20487 18.454 1.10899C18.2401 1 17.9601 1 17.4 1H2.6C2.03995 1 1.75992 1 1.54601 1.10899C1.35785 1.20487 1.20487 1.35785 1.10899 1.54601C1 1.75992 1 2.03995 1 2.6V5.4C1 5.96005 1 6.24008 1.10899 6.45399C1.20487 6.64215 1.35785 6.79513 1.54601 6.89101C1.75992 7 2.03995 7 2.6 7Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const DiversIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='18' viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M3 13V17M4 1V5M5 15H1M6 3H2M11 1L12.7528 5.44437C12.9407 5.92083 13.0347 6.15906 13.1786 6.35994C13.3061 6.538 13.462 6.69391 13.6401 6.82143C13.8409 6.9653 14.0792 7.05925 14.5556 7.24717L19 9L14.5556 10.7528C14.0792 10.9407 13.8409 11.0347 13.6401 11.1786C13.462 11.3061 13.3061 11.462 13.1786 11.6401C13.0347 11.8409 12.9407 12.0792 12.7528 12.5556L11 17L9.24717 12.5556C9.05925 12.0792 8.9653 11.8409 8.82143 11.6401C8.69391 11.462 8.538 11.3061 8.35994 11.1786C8.15906 11.0347 7.92083 10.9407 7.44437 10.7528L3 9L7.44437 7.24717C7.92083 7.05925 8.15906 6.9653 8.35994 6.82143C8.538 6.69391 8.69391 6.538 8.82143 6.35994C8.9653 6.15906 9.05925 5.92083 9.24717 5.44437L11 1Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const RevisionIcon = ({ className = '' }) => {
	return (
		<svg width='18' height='20' viewBox='0 0 18 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M16.7145 1V19M6.4285 1L1.28564 19M11.5714 1L8.99993 19'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const Icon404 = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M1.51256 1.51281C1.64162 1.38375 1.79087 1.27487 1.95552 1.19098C2.32986 1.00024 2.81991 1.00024 3.8 1.00024H12.2C13.1801 1.00024 13.6701 1.00024 14.0445 1.19098C14.2091 1.27487 14.3584 1.38375 14.4874 1.51281M1.51256 1.51281C1.3835 1.64187 1.27463 1.79112 1.19074 1.95576C1 2.33011 1 2.82015 1 3.80024V12.2002C1 13.1803 1 13.6704 1.19074 14.0447C1.27463 14.2094 1.3835 14.3586 1.51256 14.4877M1.51256 1.51281L14.4874 14.4877M14.4874 1.51281C14.6165 1.64187 14.7254 1.79112 14.8093 1.95576C15 2.33011 15 2.82015 15 3.80024V12.2002C15 13.1803 15 13.6704 14.8093 14.0447C14.7254 14.2094 14.6165 14.3586 14.4874 14.4877M14.4874 1.51281L1.51256 14.4877M1.51256 14.4877C1.64162 14.6167 1.79087 14.7256 1.95552 14.8095C2.32986 15.0002 2.81991 15.0002 3.8 15.0002H12.2C13.1801 15.0002 13.6701 15.0002 14.0445 14.8095C14.2091 14.7256 14.3584 14.6167 14.4874 14.4877'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ButtonIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='16' viewBox='0 0 20 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M19 5.50049C19 7.98577 14.9706 10.0005 10 10.0005C5.02944 10.0005 1 7.98577 1 5.50049M19 5.50049C19 3.01521 14.9706 1.00049 10 1.00049C5.02944 1.00049 1 3.01521 1 5.50049M19 5.50049V11.0005C19 13.2096 14.9706 15.0005 10 15.0005C5.02944 15.0005 1 13.2096 1 11.0005V5.50049'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const DuplicateIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M4.5 4.5H3.8C2.81991 4.5 2.32986 4.5 1.95552 4.69074C1.62623 4.85852 1.35852 5.12623 1.19074 5.45552C1 5.82986 1 6.31991 1 7.3V12.2C1 13.1801 1 13.6701 1.19074 14.0445C1.35852 14.3738 1.62623 14.6415 1.95552 14.8093C2.32986 15 2.81991 15 3.8 15H8.7C9.68009 15 10.1701 15 10.5445 14.8093C10.8738 14.6415 11.1415 14.3738 11.3093 14.0445C11.5 13.6701 11.5 13.1801 11.5 12.2V11.5M7.3 11.5H12.2C13.1801 11.5 13.6701 11.5 14.0445 11.3093C14.3738 11.1415 14.6415 10.8738 14.8093 10.5445C15 10.1701 15 9.68009 15 8.7V3.8C15 2.81991 15 2.32986 14.8093 1.95552C14.6415 1.62623 14.3738 1.35852 14.0445 1.19074C13.6701 1 13.1801 1 12.2 1H7.3C6.31991 1 5.82986 1 5.45552 1.19074C5.12623 1.35852 4.85852 1.62623 4.69074 1.95552C4.5 2.32986 4.5 2.81991 4.5 3.8V8.7C4.5 9.68009 4.5 10.1701 4.69074 10.5445C4.85852 10.8738 5.12623 11.1415 5.45552 11.3093C5.82986 11.5 6.31991 11.5 7.3 11.5Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const DeleteIcon = ({ className = '' }) => {
	return (
		<svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M1 3.33333H13.4444M10.3333 3.33333L10.1228 2.70183C9.91884 2.08986 9.81685 1.78388 9.62767 1.55765C9.46061 1.35788 9.24606 1.20325 9.00372 1.10794C8.72928 1 8.40674 1 7.76167 1H6.68278C6.0377 1 5.71517 1 5.44073 1.10794C5.19838 1.20325 4.98384 1.35788 4.81678 1.55765C4.6276 1.78388 4.5256 2.08986 4.32161 2.70183L4.11111 3.33333M11.8889 3.33333V11.2667C11.8889 12.5735 11.8889 13.2269 11.6346 13.726C11.4109 14.165 11.0539 14.522 10.6149 14.7457C10.1157 15 9.46234 15 8.15556 15H6.28889C4.9821 15 4.32871 15 3.82958 14.7457C3.39053 14.522 3.03358 14.165 2.80987 13.726C2.55556 13.2269 2.55556 12.5735 2.55556 11.2667V3.33333M8.77778 6.44444V11.8889M5.66667 6.44444V11.8889'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ArrowIcon = ({ className = '', pathClassName = 'currentColor' }) => {
	return (
		<svg
			className={className}
			width='14'
			height='8'
			viewBox='0 0 14 8'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M1 1L7 7L13 1'
				stroke={pathClassName}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const EditIcon = ({ className = '' }) => {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M10.7239 2.94231L12.9242 5.14262M8.77928 14.9997H15.0027M1 15L1.03691 14.7416C1.16754 13.8272 1.23285 13.3701 1.38141 12.9432C1.51324 12.5645 1.69332 12.2043 1.91722 11.8716C2.16955 11.4967 2.4961 11.1701 3.14921 10.517L12.2105 1.4557C12.8181 0.848101 13.8032 0.848099 14.4108 1.4557C15.0184 2.0633 15.0184 3.04841 14.4108 3.65601L5.18326 12.8836C4.59076 13.4761 4.2945 13.7723 3.95706 14.0079C3.65754 14.2171 3.3345 14.3903 2.99459 14.5241C2.61164 14.6748 2.20093 14.7577 1.37957 14.9234L1 15Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const SelectedPreviewItem = ({ className = '', svgClass = 'size-5' }) => {
	return (
		<svg
			className={svgClass}
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				className={className}
				d='M8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75Z'
				fill='black'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				className={className}
				d='M5.59979 8L7.07672 9.6L10.3998 6'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const SortableIcon = ({ className = '' }) => {
	return (
		<svg width='18' height='6' viewBox='0 0 18 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M1 1H17M1 5H17'
				stroke='black'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ClosePanelIcon = ({ className = '' }) => {
	return (
		<svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.292893 0.293137C0.683417 -0.097387 1.31658 -0.097387 1.70711 0.293137L5 3.58603L8.29289 0.293137C8.68342 -0.097387 9.31658 -0.097387 9.70711 0.293137C10.0976 0.683662 10.0976 1.31683 9.70711 1.70735L6.41421 5.00024L9.70711 8.29314C10.0976 8.68366 10.0976 9.31683 9.70711 9.70735C9.31658 10.0979 8.68342 10.0979 8.29289 9.70735L5 6.41446L1.70711 9.70735C1.31658 10.0979 0.683417 10.0979 0.292893 9.70735C-0.0976311 9.31683 -0.0976311 8.68366 0.292893 8.29314L3.58579 5.00024L0.292893 1.70735C-0.0976311 1.31683 -0.0976311 0.683662 0.292893 0.293137Z'
				fill='#1B30F5'
				className={className}
			/>
		</svg>
	);
};

export const SmallArrowIconUp = () => {
	return (
		<svg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M7 4L4 1L1 4'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};
export const SmallArrowIconDown = () => {
	return (
		<svg width='8' height='5' viewBox='0 0 8 5' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M1 1L4 4L7 1'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const CompositionIcon = ({ className = '' }) => {
	return (
		<svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				className={className}
				d='M16.125 12.25V19M12.75 15.625H19.5M14.55 7.75H17.7C18.3301 7.75 18.6451 7.75 18.8857 7.62738C19.0974 7.51952 19.2695 7.34742 19.3774 7.13574C19.5 6.89509 19.5 6.58006 19.5 5.95V2.8C19.5 2.16994 19.5 1.85491 19.3774 1.61426C19.2695 1.40258 19.0974 1.23048 18.8857 1.12262C18.6451 1 18.3301 1 17.7 1H14.55C13.9199 1 13.6049 1 13.3643 1.12262C13.1526 1.23048 12.9805 1.40258 12.8726 1.61426C12.75 1.85491 12.75 2.16994 12.75 2.8V5.95C12.75 6.58006 12.75 6.89509 12.8726 7.13574C12.9805 7.34742 13.1526 7.51952 13.3643 7.62738C13.6049 7.75 13.9199 7.75 14.55 7.75ZM3.3 7.75H6.45C7.08006 7.75 7.39509 7.75 7.63574 7.62738C7.84742 7.51952 8.01952 7.34742 8.12738 7.13574C8.25 6.89509 8.25 6.58006 8.25 5.95V2.8C8.25 2.16994 8.25 1.85491 8.12738 1.61426C8.01952 1.40258 7.84742 1.23048 7.63574 1.12262C7.39509 1 7.08006 1 6.45 1H3.3C2.66994 1 2.35491 1 2.11426 1.12262C1.90258 1.23048 1.73048 1.40258 1.62262 1.61426C1.5 1.85491 1.5 2.16994 1.5 2.8V5.95C1.5 6.58006 1.5 6.89509 1.62262 7.13574C1.73048 7.34742 1.90258 7.51952 2.11426 7.62738C2.35491 7.75 2.66994 7.75 3.3 7.75ZM3.3 19H6.45C7.08006 19 7.39509 19 7.63574 18.8774C7.84742 18.7695 8.01952 18.5974 8.12738 18.3857C8.25 18.1451 8.25 17.8301 8.25 17.2V14.05C8.25 13.4199 8.25 13.1049 8.12738 12.8643C8.01952 12.6526 7.84742 12.4805 7.63574 12.3726C7.39509 12.25 7.08006 12.25 6.45 12.25H3.3C2.66994 12.25 2.35491 12.25 2.11426 12.3726C1.90258 12.4805 1.73048 12.6526 1.62262 12.8643C1.5 13.1049 1.5 13.4199 1.5 14.05V17.2C1.5 17.8301 1.5 18.1451 1.62262 18.3857C1.73048 18.5974 1.90258 18.7695 2.11426 18.8774C2.35491 19 2.66994 19 3.3 19Z'
				stroke='#BCCCFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const WarningIcon = ({ className = '' }) => {
	return (
		<svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M6.17382 0.523703C6.46301 0.234512 6.6076 0.0899169 6.77434 0.0357409C6.92101 -0.0119136 7.07899 -0.0119136 7.22566 0.0357408C7.39239 0.0899167 7.53699 0.234512 7.82618 0.523702L8.84853 1.54605C8.97483 1.67235 9.03798 1.7355 9.11167 1.78066C9.17701 1.82069 9.24824 1.8502 9.32275 1.86809C9.40679 1.88826 9.4961 1.88827 9.67471 1.88827H10.9433C11.3523 1.88827 11.5568 1.88827 11.713 1.96786C11.8504 2.03787 11.9621 2.14958 12.0321 2.28699C12.1117 2.4432 12.1117 2.64768 12.1117 3.05666V4.32529C12.1117 4.5039 12.1117 4.59321 12.1319 4.67725C12.1498 4.75176 12.1793 4.82299 12.2193 4.88833C12.2645 4.96203 12.3277 5.02517 12.4539 5.15147L13.4763 6.17382C13.7655 6.46301 13.9101 6.6076 13.9643 6.77434C14.0119 6.92101 14.0119 7.07899 13.9643 7.22566C13.9101 7.3924 13.7655 7.53699 13.4763 7.82618L12.454 8.84853C12.3277 8.97483 12.2645 9.03798 12.2193 9.11167C12.1793 9.17701 12.1498 9.24824 12.1319 9.32275C12.1117 9.40679 12.1117 9.4961 12.1117 9.67471V10.9433C12.1117 11.3523 12.1117 11.5568 12.0321 11.713C11.9621 11.8504 11.8504 11.9621 11.713 12.0321C11.5568 12.1117 11.3523 12.1117 10.9433 12.1117H9.67471C9.4961 12.1117 9.40679 12.1117 9.32275 12.1319C9.24824 12.1498 9.17701 12.1793 9.11167 12.2193C9.03798 12.2645 8.97483 12.3277 8.84853 12.4539L7.82618 13.4763C7.53699 13.7655 7.39239 13.9101 7.22566 13.9643C7.07899 14.0119 6.92101 14.0119 6.77434 13.9643C6.6076 13.9101 6.46301 13.7655 6.17382 13.4763L5.15147 12.454C5.02517 12.3277 4.96203 12.2645 4.88833 12.2193C4.82299 12.1793 4.75176 12.1498 4.67725 12.1319C4.59321 12.1117 4.5039 12.1117 4.32529 12.1117H3.05666C2.64768 12.1117 2.4432 12.1117 2.28699 12.0321C2.14958 11.9621 2.03787 11.8504 1.96786 11.713C1.88827 11.5568 1.88827 11.3523 1.88827 10.9433V9.67471C1.88827 9.4961 1.88826 9.40679 1.86809 9.32275C1.8502 9.24824 1.82069 9.17701 1.78066 9.11167C1.7355 9.03798 1.67235 8.97483 1.54605 8.84853L0.523703 7.82618C0.234512 7.53699 0.0899168 7.3924 0.0357409 7.22566C-0.0119136 7.07899 -0.0119136 6.92101 0.0357409 6.77434C0.0899168 6.6076 0.234512 6.46301 0.523703 6.17382L1.54605 5.15147C1.67235 5.02517 1.7355 4.96203 1.78066 4.88833C1.82069 4.82299 1.8502 4.75176 1.86809 4.67725C1.88826 4.59321 1.88827 4.5039 1.88827 4.32529V3.05666C1.88827 2.64768 1.88827 2.4432 1.96786 2.28699C2.03787 2.14958 2.14958 2.03787 2.28699 1.96786C2.4432 1.88827 2.64768 1.88827 3.05666 1.88827H4.32529C4.5039 1.88827 4.59321 1.88826 4.67725 1.86809C4.75176 1.8502 4.82299 1.82069 4.88833 1.78066C4.96203 1.7355 5.02517 1.67235 5.15147 1.54605C5.55072 1.1468 5.77457 0.922954 6.17382 0.523703Z'
				fill='#1B30F5'
				className={className}
			/>
			<path
				d='M7 3V7M7 10H7.02'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ErrorIcon = ({ className = '' }) => {
	return (
		<svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M12.5283 13.9172C9.75125 16.6943 5.24874 16.6943 2.47168 13.9172C1.08315 12.5287 0.388888 10.7088 0.388885 8.88889C0.388883 7.069 1.08315 5.2491 2.47168 3.86057C2.47168 3.86057 3.05559 5.3333 4.83337 6.22219C4.83337 4.44441 5.27781 1.77774 7.48745 0C9.27777 1.77778 11.1366 2.46884 12.5283 3.86057C13.9168 5.2491 14.6111 7.069 14.6111 8.88889C14.6111 10.7088 13.9168 12.5287 12.5283 13.9172Z'
				fill='#C7092E'
				className={className}
			/>
			<path
				d='M7.94444 6.22222V9.77778M7.94444 12.4444H7.96222'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ResetIcon = ({ fillClass = '', strokeClass = '' }) => {
	return (
		<svg width='22' height='16' viewBox='0 0 22 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M16.3738 13.4456C16.6706 13.1568 16.6772 12.6819 16.3883 12.3851C16.0995 12.0882 15.6247 12.0816 15.3278 12.3705L16.3738 13.4456ZM11 14.128C7.57213 14.128 4.79346 11.3496 4.79346 7.92234H3.29346C3.29346 12.1782 6.74387 15.628 11 15.628V14.128ZM15.3278 12.3705C14.209 13.4589 12.6834 14.128 11 14.128V15.628C13.0896 15.628 14.9863 14.7955 16.3738 13.4456L15.3278 12.3705ZM4.79346 7.92234V6.18341H3.29346V7.92234H4.79346Z'
				className={fillClass}
			/>
			<path
				d='M17.9565 7.92456L17.2065 7.92431L17.2065 7.92456L17.9565 7.92456ZM5.62805 2.39725C5.33106 2.68599 5.32438 3.16082 5.61312 3.45781C5.90187 3.75479 6.37669 3.76148 6.67368 3.47273L5.62805 2.39725ZM11.0021 1.71658C14.4299 1.7177 17.2077 4.49708 17.2065 7.92431L18.7065 7.9248C18.7079 3.66898 15.2587 0.217968 11.0025 0.216577L11.0021 1.71658ZM6.67368 3.47273C7.7928 2.38468 9.31861 1.71603 11.0021 1.71658L11.0025 0.216577C8.91293 0.215894 7.01598 1.04785 5.62805 2.39725L6.67368 3.47273ZM17.2065 7.92456L17.2065 9.66125L18.7065 9.66125L18.7065 7.92456L17.2065 7.92456Z'
				className={fillClass}
			/>
			<path
				d='M1 8.7918L4.04348 6.18341L7.08695 8.7918'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				className={strokeClass}
			/>
			<path
				d='M21 7.05286L17.9565 9.66125L14.913 7.05286'
				className={strokeClass}
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ColorResetIcon = () => {
	return (
		<svg
			width='100%'
			height='100%'
			viewBox='0 0 26 26'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='13' cy='13' r='12.25' fill='white' stroke='black' strokeWidth='1.5' />
			<path d='M22 4L4 22' stroke='black' strokeWidth='1.5' />
		</svg>
	);
};

export const RemoveIconBig = ({ className = '' }) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			fill='red'
			viewBox='0 0 24 24'
			stroke='red'
			aria-hidden='true'
			className={className}
		>
			<path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
		</svg>
	);
};

export const ContainerLargeIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<rect x='7' y='7.91669' width='36' height='21.1667' rx='2' fill='#D9E2FF' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.80003 29.0833L18.8059 16.0098C19.2062 15.4868 19.9939 15.4868 20.3941 16.0098L26.1369 23.5131L29.6382 19.3958C30.0376 18.9262 30.7625 18.9262 31.1618 19.3958L39.4 29.0833H21.4L21.4 29.0833H8.80003Z'
				fill='#BCCCFF'
			/>
			<ellipse cx='34.9001' cy='14.0903' rx='2.7' ry='2.64583' fill='#BCCCFF' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1 33.5833C20.1 33.3072 20.3239 33.0833 20.6 33.0833H25.4889C25.765 33.0833 25.9889 33.3072 25.9889 33.5833V35.0833C25.9889 35.3595 25.765 35.5833 25.4889 35.5833C25.2128 35.5833 24.9889 35.3595 24.9889 35.0833V34.0833H23.5445V41.0833H24.0222C24.2984 41.0833 24.5222 41.3072 24.5222 41.5833C24.5222 41.8595 24.2984 42.0833 24.0222 42.0833H22.0667C21.7905 42.0833 21.5667 41.8595 21.5667 41.5833C21.5667 41.3072 21.7905 41.0833 22.0667 41.0833H22.5445V34.0833H21.1V35.0833C21.1 35.3595 20.8761 35.5833 20.6 35.5833C20.3239 35.5833 20.1 35.3595 20.1 35.0833V33.5833ZM24.9889 37.5833C24.9889 37.3072 25.2128 37.0833 25.4889 37.0833H29.4C29.6761 37.0833 29.9 37.3072 29.9 37.5833V38.5833C29.9 38.8595 29.6761 39.0833 29.4 39.0833C29.1239 39.0833 28.9 38.8595 28.9 38.5833V38.0833H27.9445V41.0833H28.4222C28.6984 41.0833 28.9222 41.3072 28.9222 41.5833C28.9222 41.8595 28.6984 42.0833 28.4222 42.0833H26.4667C26.1905 42.0833 25.9667 41.8595 25.9667 41.5833C25.9667 41.3072 26.1905 41.0833 26.4667 41.0833H26.9445V38.0833H25.9889V38.5833C25.9889 38.8595 25.765 39.0833 25.4889 39.0833C25.2128 39.0833 24.9889 38.8595 24.9889 38.5833V37.5833Z'
				fill='black'
			/>
		</svg>
	);
};

export const ContainerBoxIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<rect x='7' y='7' width='36' height='36' rx='4' fill='#1B30F5' />
			<rect x='9.93057' y='9.45837' width='30.1389' height='18.0833' rx='2' fill='#D9E2FF' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M11.4375 27.5416L19.6792 16.5528C20.0792 16.0194 20.8792 16.0194 21.2792 16.5528L25.9518 22.7829L28.7527 19.4218C29.1525 18.9421 29.8893 18.9421 30.2891 19.4218L37.0556 27.5416H29.5208L29.5208 27.5416H11.4375Z'
				fill='#BCCCFF'
			/>
			<circle cx='33.2882' cy='14.7326' r='2.26041' fill='#BCCCFF' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1 32.0416C20.1 31.7655 20.3239 31.5416 20.6 31.5416H25.4889C25.765 31.5416 25.9889 31.7655 25.9889 32.0416V33.5416C25.9889 33.8178 25.765 34.0416 25.4889 34.0416C25.2128 34.0416 24.9889 33.8178 24.9889 33.5416V32.5416H23.5445V39.5416H24.0222C24.2984 39.5416 24.5222 39.7655 24.5222 40.0416C24.5222 40.3178 24.2984 40.5416 24.0222 40.5416H22.0667C21.7905 40.5416 21.5667 40.3178 21.5667 40.0416C21.5667 39.7655 21.7905 39.5416 22.0667 39.5416H22.5445V32.5416H21.1V33.5416C21.1 33.8178 20.8761 34.0416 20.6 34.0416C20.3239 34.0416 20.1 33.8178 20.1 33.5416V32.0416ZM24.9889 36.0416C24.9889 35.7655 25.2128 35.5416 25.4889 35.5416H29.4C29.6761 35.5416 29.9 35.7655 29.9 36.0416V37.0416C29.9 37.3178 29.6761 37.5416 29.4 37.5416C29.1239 37.5416 28.9 37.3178 28.9 37.0416V36.5416H27.9445V39.5416H28.4222C28.6984 39.5416 28.9222 39.7655 28.9222 40.0416C28.9222 40.3178 28.6984 40.5416 28.4222 40.5416H26.4667C26.1905 40.5416 25.9667 40.3178 25.9667 40.0416C25.9667 39.7655 26.1905 39.5416 26.4667 39.5416H26.9445V36.5416H25.9889V37.0416C25.9889 37.3178 25.765 37.5416 25.4889 37.5416C25.2128 37.5416 24.9889 37.3178 24.9889 37.0416V36.0416Z'
				fill='white'
			/>
		</svg>
	);
};

export const AlignLeftIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M7 17.5714C7 17.2953 7.22386 17.0714 7.5 17.0714H12.3889C12.665 17.0714 12.8889 17.2953 12.8889 17.5714V19.0714C12.8889 19.3476 12.665 19.5714 12.3889 19.5714C12.1127 19.5714 11.8889 19.3476 11.8889 19.0714V18.0714H10.4444V25.0714H10.9222C11.1984 25.0714 11.4222 25.2953 11.4222 25.5714C11.4222 25.8476 11.1984 26.0714 10.9222 26.0714H8.96667C8.69052 26.0714 8.46667 25.8476 8.46667 25.5714C8.46667 25.2953 8.69052 25.0714 8.96667 25.0714H9.44444V18.0714H8V19.0714C8 19.3476 7.77614 19.5714 7.5 19.5714C7.22386 19.5714 7 19.3476 7 19.0714V17.5714ZM11.8889 21.5714C11.8889 21.2953 12.1127 21.0714 12.3889 21.0714H16.3C16.5761 21.0714 16.8 21.2953 16.8 21.5714V22.5714C16.8 22.8476 16.5761 23.0714 16.3 23.0714C16.0239 23.0714 15.8 22.8476 15.8 22.5714V22.0714H14.8444V25.0714H15.3222C15.5984 25.0714 15.8222 25.2953 15.8222 25.5714C15.8222 25.8476 15.5984 26.0714 15.3222 26.0714H13.3667C13.0905 26.0714 12.8667 25.8476 12.8667 25.5714C12.8667 25.2953 13.0905 25.0714 13.3667 25.0714H13.8444V22.0714H12.8889V22.5714C12.8889 22.8476 12.665 23.0714 12.3889 23.0714C12.1127 23.0714 11.8889 22.8476 11.8889 22.5714V21.5714Z'
				fill='black'
			/>
			<rect x='7' y='29.0714' width='14.1429' height='3.85714' rx='1.92857' fill='#1B30F5' />
		</svg>
	);
};

export const AlignCenterIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1 17.5714C20.1 17.2953 20.3239 17.0714 20.6 17.0714H25.4889C25.765 17.0714 25.9889 17.2953 25.9889 17.5714V19.0714C25.9889 19.3476 25.765 19.5714 25.4889 19.5714C25.2128 19.5714 24.9889 19.3476 24.9889 19.0714V18.0714H23.5445V25.0714H24.0222C24.2984 25.0714 24.5222 25.2953 24.5222 25.5714C24.5222 25.8476 24.2984 26.0714 24.0222 26.0714H22.0667C21.7905 26.0714 21.5667 25.8476 21.5667 25.5714C21.5667 25.2953 21.7905 25.0714 22.0667 25.0714H22.5445V18.0714H21.1V19.0714C21.1 19.3476 20.8761 19.5714 20.6 19.5714C20.3239 19.5714 20.1 19.3476 20.1 19.0714V17.5714ZM24.9889 21.5714C24.9889 21.2953 25.2128 21.0714 25.4889 21.0714H29.4C29.6761 21.0714 29.9 21.2953 29.9 21.5714V22.5714C29.9 22.8476 29.6761 23.0714 29.4 23.0714C29.1239 23.0714 28.9 22.8476 28.9 22.5714V22.0714H27.9445V25.0714H28.4222C28.6984 25.0714 28.9222 25.2953 28.9222 25.5714C28.9222 25.8476 28.6984 26.0714 28.4222 26.0714H26.4667C26.1905 26.0714 25.9667 25.8476 25.9667 25.5714C25.9667 25.2953 26.1905 25.0714 26.4667 25.0714H26.9445V22.0714H25.9889V22.5714C25.9889 22.8476 25.765 23.0714 25.4889 23.0714C25.2128 23.0714 24.9889 22.8476 24.9889 22.5714V21.5714Z'
				fill='black'
			/>
			<rect x='17.9286' y='29.0714' width='14.1429' height='3.85714' rx='1.92857' fill='#1B30F5' />
		</svg>
	);
};

export const AlignRightIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<g clipPath='url(#clip0_2209_753)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.2 17.5714C33.2 17.2953 33.4239 17.0714 33.7 17.0714H38.5889C38.865 17.0714 39.0889 17.2953 39.0889 17.5714V19.0714C39.0889 19.3476 38.865 19.5714 38.5889 19.5714C38.3127 19.5714 38.0889 19.3476 38.0889 19.0714V18.0714H36.6444V25.0714H37.1222C37.3984 25.0714 37.6222 25.2953 37.6222 25.5714C37.6222 25.8476 37.3984 26.0714 37.1222 26.0714H35.1667C34.8905 26.0714 34.6667 25.8476 34.6667 25.5714C34.6667 25.2953 34.8905 25.0714 35.1667 25.0714H35.6444V18.0714H34.2V19.0714C34.2 19.3476 33.9761 19.5714 33.7 19.5714C33.4239 19.5714 33.2 19.3476 33.2 19.0714V17.5714ZM38.0889 21.5714C38.0889 21.2953 38.3127 21.0714 38.5889 21.0714H42.5C42.7761 21.0714 43 21.2953 43 21.5714V22.5714C43 22.8476 42.7761 23.0714 42.5 23.0714C42.2239 23.0714 42 22.8476 42 22.5714V22.0714H41.0444V25.0714H41.5222C41.7984 25.0714 42.0222 25.2953 42.0222 25.5714C42.0222 25.8476 41.7984 26.0714 41.5222 26.0714H39.5667C39.2905 26.0714 39.0667 25.8476 39.0667 25.5714C39.0667 25.2953 39.2905 25.0714 39.5667 25.0714H40.0444V22.0714H39.0889V22.5714C39.0889 22.8476 38.865 23.0714 38.5889 23.0714C38.3127 23.0714 38.0889 22.8476 38.0889 22.5714V21.5714Z'
					fill='black'
				/>
				<rect x='28.8571' y='29.0714' width='14.1429' height='3.85714' rx='1.92857' fill='#1B30F5' />
			</g>
			<defs>
				<clipPath id='clip0_2209_753'>
					<rect x='7' y='7' width='36' height='36' rx='1' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const AlignSpecialIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M20.1 17.5C20.1 17.2239 20.3239 17 20.6 17H25.4889C25.765 17 25.9889 17.2239 25.9889 17.5V19C25.9889 19.2761 25.765 19.5 25.4889 19.5C25.2127 19.5 24.9889 19.2761 24.9889 19V18H23.5444V25H24.0222C24.2984 25 24.5222 25.2239 24.5222 25.5C24.5222 25.7761 24.2984 26 24.0222 26H22.0667C21.7905 26 21.5667 25.7761 21.5667 25.5C21.5667 25.2239 21.7905 25 22.0667 25H22.5444V18H21.1V19C21.1 19.2761 20.8761 19.5 20.6 19.5C20.3239 19.5 20.1 19.2761 20.1 19V17.5ZM24.9889 21.5C24.9889 21.2239 25.2127 21 25.4889 21H29.4C29.6761 21 29.9 21.2239 29.9 21.5V22.5C29.9 22.7761 29.6761 23 29.4 23C29.1239 23 28.9 22.7761 28.9 22.5V22H27.9444V25H28.4222C28.6984 25 28.9222 25.2239 28.9222 25.5C28.9222 25.7761 28.6984 26 28.4222 26H26.4667C26.1905 26 25.9667 25.7761 25.9667 25.5C25.9667 25.2239 26.1905 25 26.4667 25H26.9444V22H25.9889V22.5C25.9889 22.7761 25.765 23 25.4889 23C25.2127 23 24.9889 22.7761 24.9889 22.5V21.5Z'
				fill='black'
			/>
			<rect x='7' y='29' width='14.1429' height='3.85714' rx='1.92857' fill='#1B30F5' />
		</svg>
	);
};

export const UnderlineIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				d='M17 34H33M31 17V24C31 27.3137 28.3137 30 25 30C21.6863 30 19 27.3137 19 24V17M17 16H21M29 16H33'
				stroke='black'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const NoneIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				d='M31.364 31.364C34.8787 27.8492 34.8787 22.1508 31.364 18.636C27.8492 15.1213 22.1508 15.1213 18.636 18.636M31.364 31.364C27.8492 34.8787 22.1508 34.8787 18.636 31.364C15.1213 27.8492 15.1213 22.1508 18.636 18.636M31.364 31.364L18.636 18.636'
				stroke='#BCCCFF'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ImageSquareIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<rect x='7' y='14.4167' width='36' height='21.1667' rx='2' fill='#D9E2FF' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M8.80003 35.5833L18.8059 22.5098C19.2062 21.9868 19.9939 21.9868 20.3941 22.5098L26.1369 30.0131L29.6382 25.8958C30.0376 25.4262 30.7625 25.4262 31.1618 25.8958L39.4 35.5833H21.4L21.4 35.5833H8.80003Z'
				fill='#BCCCFF'
			/>
			<ellipse cx='34.9001' cy='20.5903' rx='2.7' ry='2.64583' fill='#BCCCFF' />
		</svg>
	);
};

export const ImageRoundIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<mask id='mask0_440_2485' maskUnits='userSpaceOnUse' x='12' y='12' width='26' height='26'>
				<rect x='12.5' y='12.5' width='25' height='25' rx='12.5' fill='#D9E2FF' />
			</mask>
			<g mask='url(#mask0_440_2485)'>
				<rect x='12.5' y='12.5' width='25' height='25' rx='1' fill='#D9E2FF' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.44447 37.8333L17.3111 23.3444C17.7111 22.8111 18.5111 22.8111 18.9111 23.3444L25.1726 31.693L29.0096 27.0885C29.4094 26.6088 30.1463 26.6088 30.546 27.0885L39.5 37.8333H20.0556L20.0556 37.8333H6.44447Z'
					fill='#BCCCFF'
				/>
				<circle cx='31.639' cy='19.3055' r='2.91667' fill='#BCCCFF' />
			</g>
		</svg>
	);
};

export const PaginationWithBgIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				d='M12 25L5 25M5 25L8 28M5 25L8 22'
				stroke='black'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<rect x='14' y='20' width='10' height='10' rx='3' fill='#1B30F5' />
			<path d='M20 22V28H19.0915V23.3653L18 23.8177V22.8842L19.9022 22H20Z' fill='white' />
			<path
				d='M33 27.086V28H29.1132V27.22L30.9512 25.1686C31.1359 24.9546 31.2816 24.7664 31.3883 24.6039C31.495 24.4387 31.5717 24.2911 31.6185 24.1611C31.668 24.0284 31.6927 23.9025 31.6927 23.7833C31.6927 23.6046 31.6641 23.4516 31.6068 23.3243C31.5496 23.1943 31.465 23.0941 31.3532 23.0237C31.2439 22.9533 31.1086 22.9181 30.9473 22.9181C30.7756 22.9181 30.6273 22.9614 30.5024 23.0481C30.3802 23.1347 30.2865 23.2552 30.2215 23.4096C30.159 23.564 30.1278 23.7387 30.1278 23.9336H29C29 23.5816 29.0807 23.2593 29.242 22.9668C29.4033 22.6716 29.6309 22.4374 29.9249 22.264C30.2189 22.088 30.5675 22 30.9707 22C31.3688 22 31.7044 22.0677 31.9776 22.2031C32.2533 22.3358 32.4615 22.5281 32.602 22.78C32.745 23.0291 32.8166 23.327 32.8166 23.6737C32.8166 23.8687 32.7867 24.0596 32.7268 24.2464C32.667 24.4306 32.5811 24.6148 32.4693 24.7989C32.36 24.9804 32.2273 25.1645 32.0712 25.3514C31.9151 25.5383 31.7421 25.7319 31.5522 25.9323L30.5649 27.086H33Z'
				fill='black'
			/>
			<path
				d='M38 25H45M45 25L42 22M45 25L42 28'
				stroke='black'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const PaginationUnderlineIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path d='M8 28L5 25L8 22' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
			<path
				d='M18.6667 22V28H17.7582V23.3653L16.6667 23.8177V22.8842L18.5689 22H18.6667Z'
				fill='black'
			/>
			<path d='M15.6667 30L20.6667 30' stroke='#1B30F5' strokeWidth='1.5' strokeLinecap='round' />
			<path
				d='M34.3333 27.086V28H30.4465V27.22L32.2845 25.1686C32.4693 24.9546 32.615 24.7664 32.7216 24.6039C32.8283 24.4387 32.905 24.2911 32.9519 24.1611C33.0013 24.0284 33.026 23.9025 33.026 23.7833C33.026 23.6046 32.9974 23.4516 32.9402 23.3243C32.8829 23.1943 32.7984 23.0941 32.6865 23.0237C32.5772 22.9533 32.4419 22.9181 32.2806 22.9181C32.1089 22.9181 31.9606 22.9614 31.8358 23.0481C31.7135 23.1347 31.6198 23.2552 31.5548 23.4096C31.4924 23.564 31.4611 23.7387 31.4611 23.9336H30.3333C30.3333 23.5816 30.414 23.2593 30.5753 22.9668C30.7366 22.6716 30.9642 22.4374 31.2582 22.264C31.5522 22.088 31.9008 22 32.3041 22C32.7021 22 33.0377 22.0677 33.3109 22.2031C33.5867 22.3358 33.7948 22.5281 33.9353 22.78C34.0784 23.0291 34.1499 23.327 34.1499 23.6737C34.1499 23.8687 34.12 24.0596 34.0602 24.2464C34.0003 24.4306 33.9145 24.6148 33.8026 24.7989C33.6933 24.9804 33.5606 25.1645 33.4045 25.3514C33.2485 25.5383 33.0754 25.7319 32.8855 25.9323L31.8982 27.086H34.3333Z'
				fill='black'
			/>
			<path d='M42 22L45 25L42 28' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
		</svg>
	);
};

export const ListingVariantClassicIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<g clipPath='url(#clip0_478_942)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M21 7.38889C21 7.17411 21.1827 7 21.4082 7H25.3991C25.6245 7 25.8073 7.17411 25.8073 7.38889V8.55556C25.8073 8.77033 25.6245 8.94444 25.3991 8.94444C25.1737 8.94444 24.9909 8.77033 24.9909 8.55556V7.77778H23.8118V13.2222H24.2018C24.4272 13.2222 24.61 13.3963 24.61 13.6111C24.61 13.8259 24.4272 14 24.2018 14H22.6054C22.38 14 22.1973 13.8259 22.1973 13.6111C22.1973 13.3963 22.38 13.2222 22.6054 13.2222H22.9955V7.77778H21.8163V8.55556C21.8163 8.77033 21.6336 8.94444 21.4082 8.94444C21.1827 8.94444 21 8.77033 21 8.55556V7.38889ZM24.9909 10.5C24.9909 10.2852 25.1737 10.1111 25.3991 10.1111H28.5918C28.8173 10.1111 29 10.2852 29 10.5V11.2778C29 11.4926 28.8173 11.6667 28.5918 11.6667C28.3664 11.6667 28.1837 11.4926 28.1837 11.2778V10.8889H27.4036V13.2222H27.7937C28.0191 13.2222 28.2018 13.3963 28.2018 13.6111C28.2018 13.8259 28.0191 14 27.7937 14H26.1973C25.9719 14 25.7891 13.8259 25.7891 13.6111C25.7891 13.3963 25.9719 13.2222 26.1973 13.2222H26.5873V10.8889H25.8073V11.2778C25.8073 11.4926 25.6245 11.6667 25.3991 11.6667C25.1737 11.6667 24.9909 11.4926 24.9909 11.2778V10.5Z'
					fill='black'
				/>
				<rect x='19' y='16' width='12' height='3' rx='1.5' fill='#1B30F5' />
				<g clipPath='url(#clip1_478_942)'>
					<rect x='7' y='30' width='17' height='13' rx='2' fill='#D9E2FF' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.63812 43L12.6309 35.2486C13.0247 34.6373 13.9186 34.6373 14.3123 35.2486L17.0024 39.425L18.492 37.3438C18.8908 36.7864 19.7195 36.7864 20.1183 37.3438L24.1664 43L19.3051 43H7.63812Z'
						fill='#BCCCFF'
					/>
					<circle cx='19.6848' cy='32.8462' r='1.84615' fill='#BCCCFF' />
				</g>
				<g clipPath='url(#clip2_478_942)'>
					<rect x='26' y='30' width='17' height='13' rx='2' fill='#D9E2FF' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M26 43.2372L31.1081 35.3068C31.5019 34.6955 32.3958 34.6955 32.7895 35.3068L35.5495 39.5916L37.0845 37.4468C37.4834 36.8894 38.312 36.8894 38.7109 37.4468L42.8551 43.2372L37.8977 43.2372H26Z'
						fill='#BCCCFF'
					/>
					<circle cx='38.2849' cy='32.8827' r='1.88265' fill='#BCCCFF' />
				</g>
			</g>
			<defs>
				<clipPath id='clip0_478_942'>
					<rect width='36' height='36' fill='white' transform='translate(7 7)' />
				</clipPath>
				<clipPath id='clip1_478_942'>
					<rect x='7' y='30' width='17' height='13' rx='2' fill='white' />
				</clipPath>
				<clipPath id='clip2_478_942'>
					<rect x='26' y='30' width='17' height='13' rx='2' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ListingVariantHeadingIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<rect width='50' height='25' fill='#1B30F5' />
			<g clipPath='url(#clip0_478_983)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M21 7.38889C21 7.17411 21.1827 7 21.4082 7H25.3991C25.6245 7 25.8073 7.17411 25.8073 7.38889V8.55556C25.8073 8.77033 25.6245 8.94444 25.3991 8.94444C25.1737 8.94444 24.9909 8.77033 24.9909 8.55556V7.77778H23.8118V13.2222H24.2018C24.4272 13.2222 24.61 13.3963 24.61 13.6111C24.61 13.8259 24.4272 14 24.2018 14H22.6054C22.38 14 22.1973 13.8259 22.1973 13.6111C22.1973 13.3963 22.38 13.2222 22.6054 13.2222H22.9955V7.77778H21.8163V8.55556C21.8163 8.77033 21.6336 8.94444 21.4082 8.94444C21.1827 8.94444 21 8.77033 21 8.55556V7.38889ZM24.9909 10.5C24.9909 10.2852 25.1737 10.1111 25.3991 10.1111H28.5918C28.8173 10.1111 29 10.2852 29 10.5V11.2778C29 11.4926 28.8173 11.6667 28.5918 11.6667C28.3664 11.6667 28.1837 11.4926 28.1837 11.2778V10.8889H27.4036V13.2222H27.7937C28.0191 13.2222 28.2018 13.3963 28.2018 13.6111C28.2018 13.8259 28.0191 14 27.7937 14H26.1973C25.9719 14 25.7891 13.8259 25.7891 13.6111C25.7891 13.3963 25.9719 13.2222 26.1973 13.2222H26.5873V10.8889H25.8073V11.2778C25.8073 11.4926 25.6245 11.6667 25.3991 11.6667C25.1737 11.6667 24.9909 11.4926 24.9909 11.2778V10.5Z'
					fill='white'
				/>
				<rect x='19' y='16' width='12' height='3' rx='1.5' fill='#D9E2FF' />
				<g clipPath='url(#clip1_478_983)'>
					<rect x='7' y='30' width='17' height='13' rx='2' fill='#D9E2FF' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M7.63812 43L12.6309 35.2486C13.0247 34.6373 13.9186 34.6373 14.3123 35.2486L17.0024 39.425L18.492 37.3438C18.8908 36.7864 19.7195 36.7864 20.1183 37.3438L24.1664 43L19.3051 43H7.63812Z'
						fill='#BCCCFF'
					/>
					<circle cx='19.6848' cy='32.8462' r='1.84615' fill='#BCCCFF' />
				</g>
				<g clipPath='url(#clip2_478_983)'>
					<rect x='26' y='30' width='17' height='13' rx='2' fill='#D9E2FF' />
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M26 43.2372L31.1081 35.3068C31.5019 34.6955 32.3958 34.6955 32.7895 35.3068L35.5495 39.5916L37.0845 37.4468C37.4834 36.8894 38.312 36.8894 38.7109 37.4468L42.8551 43.2372L37.8977 43.2372H26Z'
						fill='#BCCCFF'
					/>
					<circle cx='38.2849' cy='32.8827' r='1.88265' fill='#BCCCFF' />
				</g>
			</g>
			<defs>
				<clipPath id='clip0_478_983'>
					<rect width='36' height='36' fill='white' transform='translate(7 7)' />
				</clipPath>
				<clipPath id='clip1_478_983'>
					<rect x='7' y='30' width='17' height='13' rx='2' fill='white' />
				</clipPath>
				<clipPath id='clip2_478_983'>
					<rect x='26' y='30' width='17' height='13' rx='2' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ListingVariantBoxIcon = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<rect x='7' y='7' width='36' height='36' rx='2' fill='#1B30F5' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21 11.3889C21 11.1741 21.1827 11 21.4082 11H25.3991C25.6245 11 25.8073 11.1741 25.8073 11.3889V12.5556C25.8073 12.7703 25.6245 12.9444 25.3991 12.9444C25.1737 12.9444 24.9909 12.7703 24.9909 12.5556V11.7778H23.8118V17.2222H24.2018C24.4272 17.2222 24.61 17.3963 24.61 17.6111C24.61 17.8259 24.4272 18 24.2018 18H22.6054C22.38 18 22.1973 17.8259 22.1973 17.6111C22.1973 17.3963 22.38 17.2222 22.6054 17.2222H22.9955V11.7778H21.8163V12.5556C21.8163 12.7703 21.6336 12.9444 21.4082 12.9444C21.1827 12.9444 21 12.7703 21 12.5556V11.3889ZM24.9909 14.5C24.9909 14.2852 25.1737 14.1111 25.3991 14.1111H28.5918C28.8173 14.1111 29 14.2852 29 14.5V15.2778C29 15.4926 28.8173 15.6667 28.5918 15.6667C28.3664 15.6667 28.1837 15.4926 28.1837 15.2778V14.8889H27.4036V17.2222H27.7937C28.0191 17.2222 28.2018 17.3963 28.2018 17.6111C28.2018 17.8259 28.0191 18 27.7937 18H26.1973C25.9719 18 25.7891 17.8259 25.7891 17.6111C25.7891 17.3963 25.9719 17.2222 26.1973 17.2222H26.5873V14.8889H25.8073V15.2778C25.8073 15.4926 25.6245 15.6667 25.3991 15.6667C25.1737 15.6667 24.9909 15.4926 24.9909 15.2778V14.5Z'
				fill='white'
			/>
			<rect x='19' y='20' width='12' height='3' rx='1.5' fill='#D9E2FF' />
			<g clipPath='url(#clip0_478_1002)'>
				<rect x='9' y='28' width='15' height='13' rx='2' fill='#D9E2FF' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.63812 41L13.6309 33.2486C14.0247 32.6373 14.9186 32.6373 15.3123 33.2486L18.0024 37.425L19.492 35.3438C19.8908 34.7864 20.7195 34.7864 21.1183 35.3438L25.1664 41L20.3051 41H8.63812Z'
					fill='#BCCCFF'
				/>
				<circle cx='20.6848' cy='30.8462' r='1.84615' fill='#BCCCFF' />
			</g>
			<g clipPath='url(#clip1_478_1002)'>
				<rect x='26' y='28' width='15' height='13' rx='2' fill='#D9E2FF' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M25 41.2372L30.1081 33.3068C30.5019 32.6955 31.3958 32.6955 31.7895 33.3068L34.5495 37.5916L36.0845 35.4468C36.4834 34.8894 37.312 34.8894 37.7109 35.4468L41.8551 41.2372L36.8977 41.2372H25Z'
					fill='#BCCCFF'
				/>
				<circle cx='37.2849' cy='30.8827' r='1.88265' fill='#BCCCFF' />
			</g>
			<defs>
				<clipPath id='clip0_478_1002'>
					<rect x='9' y='28' width='15' height='13' rx='2' fill='white' />
				</clipPath>
				<clipPath id='clip1_478_1002'>
					<rect x='26' y='28' width='15' height='13' rx='2' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CloseIcon = ({ className = '' }) => {
	return (
		<svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect y='0.5' width='20' height='20' rx='6' fill='#C7092E'></rect>
			<path
				className={className}
				d='M6 6.5C9.12419 9.62419 10.8758 11.3758 14 14.5M14 6.5L6 14.5'
				stroke='white'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			></path>
		</svg>
	);
};
export const CloseIconBis = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='20' height='20' rx='6' fill='#C7092E' />
			<path
				d='M6 6C9.12419 9.12419 10.8758 10.8758 14 14M14 6L6 14'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const LockedIcon = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='20' height='20' rx='6' fill='#1B30F5' />
			<path
				d='M10.0001 11.3889V12.5M7.22233 8.90488C7.48423 8.88889 7.8071 8.88889 8.22233 8.88889H11.7779C12.1931 8.88889 12.516 8.88889 12.7779 8.90488M7.22233 8.90488C6.89549 8.92484 6.6636 8.9697 6.46568 9.07054C6.15208 9.23033 5.89711 9.4853 5.73732 9.7989C5.55566 10.1554 5.55566 10.6221 5.55566 11.5556V12.3333C5.55566 13.2668 5.55566 13.7335 5.73732 14.09C5.89711 14.4036 6.15208 14.6586 6.46568 14.8183C6.8222 15 7.28891 15 8.22233 15H11.7779C12.7113 15 13.178 15 13.5345 14.8183C13.8481 14.6586 14.1031 14.4036 14.2629 14.09C14.4446 13.7335 14.4446 13.2668 14.4446 12.3333V11.5556C14.4446 10.6221 14.4446 10.1554 14.2629 9.7989C14.1031 9.4853 13.8481 9.23033 13.5345 9.07054C13.3366 8.9697 13.1047 8.92484 12.7779 8.90488M7.22233 8.90488V7.77778C7.22233 6.24365 8.46598 5 10.0001 5C11.5342 5 12.7779 6.24365 12.7779 7.77778V8.90488'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const UnLockedIcon = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='20' height='20' rx='6' fill='#1B30F5' />
			<path
				d='M12.5468 6.66667C12.1181 5.68561 11.1392 5 10.0001 5C8.46598 5 7.22233 6.24365 7.22233 7.77778V8.90488M10.0001 11.3889V12.5M7.22233 8.90488C7.48423 8.88889 7.8071 8.88889 8.22233 8.88889H11.7779C12.7113 8.88889 13.178 8.88889 13.5345 9.07054C13.8481 9.23033 14.1031 9.4853 14.2629 9.7989C14.4446 10.1554 14.4446 10.6221 14.4446 11.5556V12.3333C14.4446 13.2668 14.4446 13.7335 14.2629 14.09C14.1031 14.4036 13.8481 14.6586 13.5345 14.8183C13.178 15 12.7113 15 11.7779 15H8.22233C7.28891 15 6.8222 15 6.46568 14.8183C6.15208 14.6586 5.89711 14.4036 5.73732 14.09C5.55566 13.7335 5.55566 13.2668 5.55566 12.3333V11.5556C5.55566 10.6221 5.55566 10.1554 5.73732 9.7989C5.89711 9.4853 6.15208 9.23033 6.46568 9.07054C6.6636 8.9697 6.89549 8.92484 7.22233 8.90488Z'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const OpacityIcon = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='20' height='20' rx='6' fill='black' />
			<path
				d='M5.284 5.28418L14.7158 14.716M8.87032 8.90685C8.59646 9.18975 8.42793 9.57523 8.42793 10.0001C8.42793 10.8682 9.13172 11.572 9.99989 11.572C10.4309 11.572 10.8213 11.3986 11.1053 11.1177M7.11796 7.19524C6.12274 7.8519 5.36471 8.83889 5 10.0001C5.66769 12.1259 7.65377 13.668 10 13.668C11.0422 13.668 12.0133 13.3638 12.8293 12.8392M9.4759 6.35804C9.64828 6.34092 9.82311 6.33216 9.99999 6.33216C12.3462 6.33216 14.3323 7.87421 15 10.0001C14.8529 10.4685 14.6418 10.9086 14.3769 11.31'
				stroke='white'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const NonOpacityIcon = () => {
	return (
		<svg width='30' height='30' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='20' height='20' rx='6' fill='#D9E2FF' />
			<path
				d='M11.5717 9.99995C11.5717 10.8681 10.8679 11.5719 9.99976 11.5719C9.13159 11.5719 8.4278 10.8681 8.4278 9.99995C8.4278 9.13178 9.13159 8.42798 9.99976 8.42798C10.8679 8.42798 11.5717 9.13178 11.5717 9.99995Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M9.99999 6.33203C7.65377 6.33203 5.6677 7.87406 5 9.99993C5.66769 12.1258 7.65377 13.6679 10 13.6679C12.3462 13.6679 14.3323 12.1258 15 9.99997C14.3323 7.87408 12.3462 6.33203 9.99999 6.33203Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const SearchIcon = ({ className = '' }) => {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M12.6342 12.6098L16 16M14.4444 8.22222C14.4444 11.6587 11.6587 14.4444 8.22222 14.4444C4.78578 14.4444 2 11.6587 2 8.22222C2 4.78578 4.78578 2 8.22222 2C11.6587 2 14.4444 4.78578 14.4444 8.22222Z'
				stroke='#1B30F5'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
				className={className}
			/>
		</svg>
	);
};

export const LayoutIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='18'
			height='18'
			viewBox='0 0 18 18'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M1 2.6C1 2.03995 1 1.75992 1.10899 1.54601C1.20487 1.35785 1.35785 1.20487 1.54601 1.10899C1.75992 1 2.03995 1 2.6 1H5.4C5.96005 1 6.24008 1 6.45399 1.10899C6.64215 1.20487 6.79513 1.35785 6.89101 1.54601C7 1.75992 7 2.03995 7 2.6V7.4C7 7.96005 7 8.24008 6.89101 8.45399C6.79513 8.64215 6.64215 8.79513 6.45399 8.89101C6.24008 9 5.96005 9 5.4 9H2.6C2.03995 9 1.75992 9 1.54601 8.89101C1.35785 8.79513 1.20487 8.64215 1.10899 8.45399C1 8.24008 1 7.96005 1 7.4V2.6Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11 10.6C11 10.0399 11 9.75992 11.109 9.54601C11.2049 9.35785 11.3578 9.20487 11.546 9.10899C11.7599 9 12.0399 9 12.6 9H15.4C15.9601 9 16.2401 9 16.454 9.10899C16.6422 9.20487 16.7951 9.35785 16.891 9.54601C17 9.75992 17 10.0399 17 10.6V15.4C17 15.9601 17 16.2401 16.891 16.454C16.7951 16.6422 16.6422 16.7951 16.454 16.891C16.2401 17 15.9601 17 15.4 17H12.6C12.0399 17 11.7599 17 11.546 16.891C11.3578 16.7951 11.2049 16.6422 11.109 16.454C11 16.2401 11 15.9601 11 15.4V10.6Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M1 14.6C1 14.0399 1 13.7599 1.10899 13.546C1.20487 13.3578 1.35785 13.2049 1.54601 13.109C1.75992 13 2.03995 13 2.6 13H5.4C5.96005 13 6.24008 13 6.45399 13.109C6.64215 13.2049 6.79513 13.3578 6.89101 13.546C7 13.7599 7 14.0399 7 14.6V15.4C7 15.9601 7 16.2401 6.89101 16.454C6.79513 16.6422 6.64215 16.7951 6.45399 16.891C6.24008 17 5.96005 17 5.4 17H2.6C2.03995 17 1.75992 17 1.54601 16.891C1.35785 16.7951 1.20487 16.6422 1.10899 16.454C1 16.2401 1 15.9601 1 15.4V14.6Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M11 2.6C11 2.03995 11 1.75992 11.109 1.54601C11.2049 1.35785 11.3578 1.20487 11.546 1.10899C11.7599 1 12.0399 1 12.6 1H15.4C15.9601 1 16.2401 1 16.454 1.10899C16.6422 1.20487 16.7951 1.35785 16.891 1.54601C17 1.75992 17 2.03995 17 2.6V3.4C17 3.96005 17 4.24008 16.891 4.45399C16.7951 4.64215 16.6422 4.79513 16.454 4.89101C16.2401 5 15.9601 5 15.4 5H12.6C12.0399 5 11.7599 5 11.546 4.89101C11.3578 4.79513 11.2049 4.64215 11.109 4.45399C11 4.24008 11 3.96005 11 3.4V2.6Z'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const ComboHeaderActionElementRound = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M23.747 8.87255C20.8136 8.87255 18.4356 11.2965 18.4356 14.2865C18.4356 17.2765 20.8136 19.7004 23.747 19.7004C26.6803 19.7004 29.0583 17.2765 29.0583 14.2865C29.0583 11.2965 26.6803 8.87255 23.747 8.87255ZM17.0891 14.2865C17.0891 10.5384 20.0699 7.5 23.747 7.5C27.424 7.5 30.4048 10.5384 30.4048 14.2865C30.4048 15.9127 29.8437 17.4053 28.908 18.5741L31.704 21.4267C31.9668 21.6948 31.9666 22.1294 31.7036 22.3973C31.4405 22.6651 31.0142 22.6649 30.7514 22.3968L27.9561 19.5449C26.809 20.5001 25.3436 21.073 23.747 21.073C20.0699 21.073 17.0891 18.0346 17.0891 14.2865ZM28.7318 28.9755C28.9948 28.7075 29.4211 28.7075 29.684 28.9755L35.2673 34.6667L40.8507 28.9755C41.1136 28.7075 41.5399 28.7075 41.8028 28.9755C42.0657 29.2435 42.0657 29.678 41.8028 29.9461L36.2195 35.6373L41.8028 41.3285C42.0657 41.5965 42.0657 42.031 41.8028 42.299C41.5399 42.567 41.1136 42.567 40.8507 42.299L35.2673 36.6078L29.684 42.299C29.4211 42.567 28.9948 42.567 28.7318 42.299C28.4689 42.031 28.4689 41.5965 28.7318 41.3285L34.3152 35.6373L28.7318 29.9461C28.4689 29.678 28.4689 29.2435 28.7318 28.9755ZM8 30.1471C8 29.768 8.30143 29.4608 8.67327 29.4608H21.802C22.1738 29.4608 22.4752 29.768 22.4752 30.1471C22.4752 30.5261 22.1738 30.8333 21.802 30.8333H8.67327C8.30143 30.8333 8 30.5261 8 30.1471ZM8 35.6373C8 35.2582 8.30143 34.951 8.67327 34.951H21.802C22.1738 34.951 22.4752 35.2582 22.4752 35.6373C22.4752 36.0163 22.1738 36.3235 21.802 36.3235H8.67327C8.30143 36.3235 8 36.0163 8 35.6373ZM8 41.1275C8 40.7484 8.30143 40.4412 8.67327 40.4412H21.802C22.1738 40.4412 22.4752 40.7484 22.4752 41.1275C22.4752 41.5065 22.1738 41.8137 21.802 41.8137H8.67327C8.30143 41.8137 8 41.5065 8 41.1275Z'
				fill='#1B30F5'
			/>
		</svg>
	);
};

export const ComboHeaderActionElementLight = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M22.3172 8.18825C19.7002 8.18825 17.5787 10.2889 17.5787 12.8801C17.5787 15.4713 19.7002 17.572 22.3172 17.572C24.9341 17.572 27.0556 15.4713 27.0556 12.8801C27.0556 10.2889 24.9341 8.18825 22.3172 8.18825ZM16.8836 12.8801C16.8836 9.90876 19.3163 7.5 22.3172 7.5C25.318 7.5 27.7507 9.90876 27.7507 12.8801C27.7507 14.2419 27.2397 15.4856 26.3972 16.4333L31.3786 21.3658C31.5144 21.5002 31.5144 21.7181 31.3786 21.8525C31.2429 21.9869 31.0229 21.9869 30.8871 21.8525L25.9057 16.92C24.9485 17.7542 23.6925 18.2602 22.3172 18.2602C19.3163 18.2602 16.8836 15.8515 16.8836 12.8801ZM35.7949 35.3742L42.5 42.0133L42.0085 42.5L35.3034 35.8608L28.5983 42.5L28.1068 42.0133L34.8119 35.3742L28.1068 28.735L28.5983 28.2483L35.3034 34.8875L42.0085 28.2483L42.5 28.735L35.7949 35.3742ZM7.5 30.2123H21.4017V30.9005H7.5V30.2123ZM9.58525 35.03H19.3164V35.7183H9.58525V35.03ZM7.5 39.8478H21.4017V40.536H7.5V39.8478Z'
				fill='#1B30F5'
			/>
		</svg>
	);
};

export const ComboHeaderActionElementSmall = () => {
	return (
		<svg width='50' height='50' viewBox='0 0 50 50' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<rect width='50' height='50' rx='10' fill='white' />
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M21.6815 8.97635C19.3941 8.97635 17.5398 10.8491 17.5398 13.1593C17.5398 15.4695 19.3941 17.3423 21.6815 17.3423C23.9688 17.3423 25.8231 15.4695 25.8231 13.1593C25.8231 10.8491 23.9688 8.97635 21.6815 8.97635ZM16.078 13.1593C16.078 10.0338 18.5867 7.5 21.6815 7.5C24.7762 7.5 27.2849 10.0338 27.2849 13.1593C27.2849 14.456 26.8531 15.6508 26.1269 16.6052L30.1864 20.7051L29.1528 21.7491L25.0932 17.6491C24.1484 18.3826 22.9653 18.8187 21.6815 18.8187C18.5867 18.8187 16.078 16.2849 16.078 13.1593ZM32.1575 33.0304L35.8119 36.7212L39.4664 33.0304L40.5 34.0743L36.8456 37.7652L40.5 41.4561L39.4664 42.5L35.8119 38.8091L32.1575 42.5L31.1239 41.4561L34.7783 37.7652L31.1239 34.0743L32.1575 33.0304ZM9.5 35.5507L9.5 34.0743L18.2706 34.0743V35.5507L9.5 35.5507ZM9.5 38.5034L9.5 37.027L18.2706 37.027V38.5034L9.5 38.5034ZM9.5 41.4561L9.5 39.9797L18.2706 39.9797V41.4561L9.5 41.4561Z'
				fill='#1B30F5'
			/>
		</svg>
	);
};

export const A11yIcon = ({ className = '' }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={className}
		>
			<circle cx='10' cy='10.0005' r='9' stroke='currentColor' strokeWidth='1.5' />
			<path
				d='M6.14307 8.71477L10.0002 10.0005L13.8574 8.71477'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.78564 15.1433L9.99993 10.0005L13.2142 15.1433'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<circle cx='9.99986' cy='5.50049' r='1.42857' fill='currentColor' stroke='currentColor' />
		</svg>
	);
};

export const KeyIcon = ({ className = '' }) => {
	return (
		<svg
			className={className}
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M17.4998 3.67549L18.0915 3.09215C18.2484 2.93523 18.3366 2.7224 18.3366 2.50049C18.3366 2.27857 18.2484 2.06574 18.0915 1.90882C17.9346 1.7519 17.7218 1.66374 17.4998 1.66374C17.2779 1.66374 17.0651 1.7519 16.9082 1.90882L15.7415 3.08382L13.3832 5.44215L8.12484 10.6922C7.2632 10.1237 6.22123 9.89529 5.20081 10.0512C4.18039 10.2072 3.25419 10.7363 2.60166 11.5362C1.94913 12.3361 1.61674 13.3497 1.6689 14.3806C1.72106 15.4116 2.15405 16.3864 2.88397 17.1164C3.61389 17.8463 4.58877 18.2793 5.61972 18.3314C6.65066 18.3836 7.66427 18.0512 8.46413 17.3987C9.26399 16.7461 9.79316 15.8199 9.94909 14.7995C10.105 13.7791 9.87664 12.7371 9.30817 11.8755L13.9665 7.20882L15.7332 8.98382C15.8109 9.06097 15.903 9.12206 16.0043 9.16361C16.1056 9.20515 16.2141 9.22634 16.3236 9.22595C16.4331 9.22556 16.5415 9.20361 16.6425 9.16135C16.7435 9.11909 16.8352 9.05735 16.9123 8.97965C16.9895 8.90195 17.0506 8.80982 17.0921 8.70851C17.1337 8.6072 17.1549 8.4987 17.1545 8.38921C17.1541 8.27971 17.1321 8.17136 17.0899 8.07035C17.0476 7.96934 16.9859 7.87764 16.9082 7.80049L15.1415 6.03382L16.3248 4.85882L16.9082 5.44215C16.9853 5.51985 17.077 5.58159 17.178 5.62385C17.279 5.66611 17.3874 5.68806 17.4969 5.68845C17.6064 5.68884 17.7149 5.66765 17.8162 5.62611C17.9175 5.58456 18.0096 5.52347 18.0873 5.44632C18.165 5.36917 18.2268 5.27747 18.269 5.17645C18.3113 5.07544 18.3332 4.96709 18.3336 4.8576C18.334 4.7481 18.3128 4.6396 18.2713 4.53829C18.2297 4.43698 18.1687 4.34485 18.0915 4.26715L17.4998 3.67549ZM5.83317 16.6672C5.33872 16.6672 4.85537 16.5205 4.44424 16.2458C4.03312 15.9711 3.71269 15.5807 3.52347 15.1239C3.33425 14.667 3.28474 14.1644 3.38121 13.6794C3.47767 13.1945 3.71577 12.749 4.0654 12.3994C4.41503 12.0498 4.86049 11.8117 5.34544 11.7152C5.8304 11.6187 6.33306 11.6682 6.78988 11.8575C7.24669 12.0467 7.63714 12.3671 7.91184 12.7782C8.18655 13.1893 8.33317 13.6727 8.33317 14.1672C8.33317 14.8302 8.06978 15.4661 7.60094 15.9349C7.1321 16.4038 6.49621 16.6672 5.83317 16.6672Z'
				fill='#1B30F5'
			/>
		</svg>
	);
};

export const PageIcon = ({ className = 'text-minos-v2-blue' }) => {
	return (
		<svg
			className={className}
			width='18'
			height='20'
			viewBox='0 0 18 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M7 13.0005H11M9 11.0005V15.0005M10 1.00049H5.2C4.0799 1.00049 3.51984 1.00049 3.09202 1.21848C2.71569 1.41022 2.40973 1.71618 2.21799 2.09251C2 2.52033 2 3.08038 2 4.20049V15.8005C2 16.9206 2 17.4806 2.21799 17.9085C2.40973 18.2848 2.71569 18.5908 3.09202 18.7825C3.51984 19.0005 4.0799 19.0005 5.2 19.0005H12.8C13.9201 19.0005 14.4802 19.0005 14.908 18.7825C15.2843 18.5908 15.5903 18.2848 15.782 17.9085C16 17.4806 16 16.9206 16 15.8005V7.00049M10 1.00049L16 7.00049M10 1.00049V5.40049C10 5.96054 10 6.24057 10.109 6.45448C10.2049 6.64264 10.3578 6.79562 10.546 6.89149C10.7599 7.00049 11.0399 7.00049 11.6 7.00049H16'
				stroke='currentColor'
				strokeWidth='1.5'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const MinotaureIcon = () => {
	return (
		<svg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M0 0.000244141H18V18.0002H5.157C2.304 18.0002 0 15.6872 0 12.8432V0.000244141Z'
				fill='#C7092E'
			/>
			<path
				d='M2.7002 12.8253V7.20028H5.0582V8.12727C5.4632 7.40728 6.5072 6.95728 7.3892 6.95728C8.5502 6.95728 9.37819 7.43428 9.7832 8.22628C10.4222 7.31728 11.1962 6.95728 12.2942 6.95728C13.8242 6.95728 15.2912 7.85728 15.2912 10.0533V15.3003H12.8972V10.6113C12.8972 9.84628 12.4922 9.24328 11.6102 9.24328C10.7282 9.24328 10.2602 9.90928 10.2602 10.6293V15.3093H7.8122V10.6203C7.8122 9.85528 7.4072 9.25227 6.5072 9.25227C5.6072 9.25227 5.1752 9.91828 5.1752 10.6563V15.3183C3.8072 15.3183 2.7002 14.2113 2.7002 12.8433V12.8253Z'
				fill='white'
			/>
		</svg>
	);
};

// NON USED

export const PlusIcon = ({ className = '' }) => {
	return (
		<svg
			strokeWidth='0'
			viewBox='0 0 1024 1024'
			height='24'
			width='24'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path className={className} d='M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z'></path>
			<path className={className} d='M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z'></path>
		</svg>
	);
};
